import styled, { css } from 'styled-components'
import { breakpoint } from '../layout/styles'

export const Tabs = styled.div`
  color: var(--text);
  display: flex;
  border-bottom: 1px var(--text) solid;
  @media print {
    display: none;
    border-bottom: none;
  }
`

export const Tab = styled.div<any>`
  border-bottom: 5px ${props => props.selected ? 'var(--primary)' : 'rgba(0,0,0,0)'} solid;
  padding-bottom: 8px;
  margin-right: 40px;
  font-weight: bold;
  cursor: pointer;
  @media print {
    display: none;
  }
`

export const Panel = styled.div<any>`
  color: var(--text);
  display: ${props => props.selected ? 'flex' : 'none'};
  flex-direction: column;
  flex-wrap: wrap;
  @media ${breakpoint.desktop} {
    flex-direction: row;
  }
  h4, h2 {
    font-size: 12px;
    text-transform: uppercase;
    margin: 0 0 24px 0;
    max-width: 350px;
    @media print {
      max-width: 100%;
    }
  }
  ul, ol {
    margin: 0;
  }
  ol > li {
    margin-bottom: 24px;
    font-weight: bold;
    & > span {
      font-weight: normal;
    }
  }
  @media print {
    display: flex;
    padding: 0 2rem;
  }
`
